import { AppColors } from "@/assets/colors";
import { AppSize, IProperties, pxToRem } from "@/util";
import { Box, Paper, Typography } from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
import Image from "next/image";
type props = {
  data: Partial<IProperties>;
};
export default function Overview({ data }: Partial<props>) {
  const { classes } = styles();
  const over: { name: string; icon: string }[] = [
    {
      name: `${data?.totalbedrooms || 0} Beds`,
      icon: "/images/overview/bed-icon.svg",
    },
    {
      name: `${data?.totalbathrooms || 0} Baths`,
      icon: "/images/overview/bath-icon.svg",
    },
    {
      name: `${data?.squaremeter || 0} Sqft`,
      icon: "/images/overview/building-icon.svg",
    },
    {
      name: `${data?.totalgarage || 0} Garages`,
      icon: "/images/overview/garage-icon.svg",
    },
    {
      name: `Year Built: ${data?.yearbuilt || "empty"}`,
      icon: "/images/overview/calender-icon.svg",
    },
  ];
  return (
    <Box className={`${classes.container}`}>
      <Box className={`${classes.desco}`}>
        <Paper className={`${classes.desc}  ${classes.pap}`}>
          <Typography className={classes.navHead}>Description</Typography>
          <Typography className={`${classes.des}`}>
            {data?.description}
          </Typography>
        </Paper>
        <Paper className={`${classes.over} ${classes.pap}`}>
          <Typography className={classes.navHead}>Overview</Typography>
          <Box className={classes.subOver}>
            {over.map((value, key) => {
              return (
                <Box key={key} className={classes.overIcon}>
                  <Image
                    src={value.icon}
                    alt="location"
                    width={24}
                    height={24}
                  />
                  <Typography className={`${classes.iconName}`}>
                    {value?.name}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: pxToRem(230),
    gap: theme.spacing(3),
    padding: `0px ${AppSize.padding}`,
    alignItems: "center",
    [theme.breakpoints.down(850)]: {
      marginTop: `150px`,
    },
    [theme.breakpoints.down("sm")]: {
      // marginTop: `0px`,
    },
  },
  debug: {
    border: "1px solid green",
  },
  nav: {
    width: "60%",
    height: pxToRem(70),
    borderRadius: pxToRem(8),
    backgroundColor: AppColors.neutral["65"],
    display: "grid",
    gridTemplateColumns: "repeat(4,1fr)",
  },
  navBtn: {
    fontWeight: 500,
    fontSize: pxToRem(20),
    color: AppColors.neutral["48"],
  },
  desco: {
    minHeight: pxToRem(204),
    display: "grid",
    gap: theme.spacing(3),
    gridTemplateColumns: "repeat(2,1fr)",
    width: "100%",
    [theme.breakpoints.down(850)]: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(3),
    },
  },
  des: {
    fontWeight: 400,
    fontSize: pxToRem(16),
    color: AppColors.text.second,
  },
  navHead: {
    fontFamily: "Playfair Display",
    fontWeight: 700,
    fontSize: pxToRem(20),
  },
  pap: {
    padding: theme.spacing(3),
    justifyContent: "space-evenly",
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  iconName: {
    fontWeight: 400,
    fontSize: pxToRem(16),
  },
  desc: {
    flex: 1,
  },
  over: {
    flex: 1,
  },
  subOver: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      gap: theme.spacing(4),
      flexDirection: "column",
    },
  },
  overIcon: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      alignItems: "flex-start",
      flexDirection: "row",
      gap: theme.spacing(2),
    },
  },
}));
